import { DeadlyDigitsThemes } from './deadlydigits';
import { ReckonThemes } from './reckon';
import { ThemeType } from './types';

export const Themes: Array<ThemeType> = [
  ...DeadlyDigitsThemes,
  ...ReckonThemes,
];
